// extracted by mini-css-extract-plugin
export default {"mainContainer":"AboutMe_mainContainer__At160","leftSection":"AboutMe_leftSection__ee3s1","rightSection":"AboutMe_rightSection__BhJuA","mainText":"AboutMe_mainText__MXqk3"};